

























import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

import { ZenObjectTable } from 'zenComponents';
import LoadingSpinner from '@reciprocity/loading-spinner';

export default Vue.extend({
  name: 'RequestList',
  components: {
    ZenObjectTable,
    LoadingSpinner,
  },
  props: {
    audit: {
      type: Object,
      required: true,
    },
  },
  data() {
    const source = this.audit.managedIn.value;
    const columns =
      source === 'JIRA'
        ? [
            'status',
            {
              key: 'name',
              label: 'Title',
            },
            'description',
            'due_date',
            'assignee',
            'reporter',
          ]
        : [
            'state',
            {
              key: 'short_description',
              label: 'Title',
            },
            'description',
          ];
    return {
      columns,
      isLoading: false,
      source,
    };
  },
  computed: {
    ...mapGetters('auditSetupWizard', ['getRemoteRequests']),
  },
  async created() {
    this.isLoading = true;
    await this.loadRemoteRequests();
    this.isLoading = false;
  },

  methods: {
    ...mapActions({
      showAlert: 'alerts/show',
    }),
    ...mapActions('auditSetupWizard', ['loadRemoteRequests']),
  },
});
